import Vue from 'vue'
import AscTextFieldInput from '@/components/atoms/AscTextFieldInput'

export default Vue.extend({
  components: {
    AscTextFieldInput,
  },

  data: function () {
    return {
      currentValue: '',
      disabled: false,
    }
  },

  beforeMount() {
    let filterText = ''
    this.disabled = Object.prototype.hasOwnProperty.call(
      this.params,
      'disabled',
    )
      ? this.params.disabled
      : false

    // Persistent filter
    if (Object.prototype.hasOwnProperty.call(this.params, 'persistentGridId')) {
      const persistentGridId = this.params.persistentGridId
      const filterModel = sessionStorage.getItem(`${persistentGridId}_filter`)
      if (filterModel) {
        const parsedFilterModel = JSON.parse(filterModel)
        if (
          Object.prototype.hasOwnProperty.call(
            parsedFilterModel,
            this.params.column.colId,
          )
        ) {
          const existingSelection =
            parsedFilterModel[this.params.column.colId].filter

          filterText =
            existingSelection && existingSelection !== ''
              ? existingSelection
              : null
        }
      }
    } else {
      console.warn('N/A persistentGridId')
    }

    if (filterText === '') {
      // Set to none
      this.currentValue = ''
      this.handleInput()
    } else {
      this.currentValue = filterText
      this.handleInput()
    }
  },

  methods: {
    handleInput() {
      if (this.currentValue === '') {
        // Remove the filter
        this.params.parentFilterInstance(instance => {
          instance.onFloatingFilterChanged(null, null)
        })
        return
      }

      this.params.parentFilterInstance(instance => {
        instance.onFloatingFilterChanged('equals', this.currentValue)
      })
    },

    onParentModelChanged(parentModel) {
      // When the filter is empty we will receive a null value here
      if (!parentModel) {
        this.currentValue = ''
      } else {
        this.currentValue = parentModel.filter
      }
    },
  },

  template: `<asc-text-field-input
  type="number"
  v-model="currentValue"
  :disabled="disabled"
  :dense="true"
  :hide-details="true"
  @input="handleInput" 
  style="margin-bottom: 0.5em;" />`,
})
